import React from 'react'
import ButtonComponent from '../../components/ButtonComponent';
import { useNavigate } from 'react-router-dom';

const IosPrivacyPolicy = () => {
    const navigate = useNavigate();
    const handleBackToPolicyPage = () => {
        navigate('/documents');
    }
    return (
        <>
            <div className="container mt-5 privacy-policy">
                <ButtonComponent title='Back to Policy Page' backgroundColor=' #590B21' onClick={handleBackToPolicyPage} />
            </div>
            <div className="container mt-2 mb-5 py-4 privacy-policy">
                <h3 className='fw-bold'>iOS Privacy Policy</h3>
                <p> Effective Date: 1st August 2025</p>
                <p>
                    Curry King (Private) Limited ("Curry King", "we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information when you use the Curry King iOS App (the "App").
                </p>
                <p>By using the App, you agree to the practices described in this Privacy Policy.</p>
                <hr />
                <h5 className='fw-bold'>1. Introduction</h5>
                <p>
                    Curry King (Private) Limited ("Curry King", "we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information when you use the Curry King iOS App (the "App").
                    By using the App, you agree to the practices described in this Privacy Policy.
                </p>
                <hr />
                <h5 className='fw-bold'>2. Information We Collect</h5>
                <p>When you use the App, we may collect the following types of information:</p>
                <ul>
                    <li>
                        <strong>Personal Information:</strong> Name, email address, phone number, delivery address, and payment details (collected during order checkout).
                    </li>
                    <li>
                        <strong>Order Information:</strong> Items ordered, preferences, and transaction history.
                    </li>
                    <li>
                        <strong>Device & Usage Data:</strong> Device type, operating system, IP address, app usage patterns, and crash reports (for improving app performance).
                    </li>
                    <li>
                        <strong>Location Data (if you allow):</strong> Used to show nearby Curry King food carts and improve delivery accuracy.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>3. How We Use Your Information</h5>
                <p>We use your information for the following purposes:</p>
                <ul>
                    <li>To process and deliver your orders.</li>
                    <li>To provide customer support and communicate about your orders.</li>
                    <li>To send promotional offers, loyalty points, and app updates (if you opt-in).</li>
                    <li>To improve app functionality, performance, and user experience.</li>
                    <li>To comply with legal obligations.</li>
                    <li>To enable cross-platform access: Your account information may be used across Curry King platforms (iOS app, Android app, and web) so you can sign in and access your orders from any device.</li>
                </ul>
                <hr />
                <h5 className='fw-bold'>4. Advertising & Tracking</h5>
                <p>
                    With your explicit consent, we may use your information to deliver personalized advertisements and marketing communications across platforms, including social media and online advertising networks.
                    We may share non-sensitive identifiers (such as a hashed email address or device ID) with advertising partners for remarketing and audience targeting.
                </p>
                <p>
                    We respect Apple's App Tracking Transparency (ATT) framework. You will be asked for permission before we track your data across apps and websites owned by other companies.
                </p>
                <p>
                    You can opt out of targeted advertising at any time by adjusting your device settings or contacting us at support@curryking.lk.
                </p>
                <hr />
                <h5 className='fw-bold'>5. Data Sharing & Disclosure</h5>
                <p>We do not sell your personal data. We may share your information only with:</p>
                <ul>
                    <li>
                        <strong>Service Providers:</strong> Payment processors, delivery partners, IT service providers, and advertising partners (for targeting ads, only with consent).
                    </li>
                    <li>
                        <strong>Legal Authorities:</strong> When required by law, regulation, or legal process.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>6. Data Storage & Retention</h5>
                <ul>
                    <li>Your personal data is securely stored on Firebase servers located in us-central"
                        kiyala daamu</li>
                    <li>We retain your data only as long as necessary to provide services and comply with legal obligations.</li>
                    <li>You may request deletion of your data by contacting us at support@curryking.lk.</li>
                </ul>
                <hr />
                <h5 className='fw-bold'>7. User Rights</h5>
                <p>You have the right to:</p>
                <ul>
                    <li>Access and review your personal data.</li>
                    <li>Correct or update your information.</li>
                    <li>Request deletion of your data.</li>
                    <li>Withdraw consent for promotional communications or targeted advertising.</li>
                </ul>
                <hr />
                <h5 className='fw-bold'>8. Security</h5>
                <p>
                    We use encryption, secure payment gateways, and industry-standard safeguards to protect your personal data from unauthorized access, disclosure, or misuse.
                </p>
                <hr />
                <h5 className='fw-bold'>9. Third-Party Services</h5>
                <p>
                    The App may use third-party services (e.g., Apple Pay, Stripe, Firebase, analytics tools, and advertising platforms). These services may collect information as described in their respective privacy policies.
                </p>
                <hr />
                <h5 className='fw-bold'>10. Children's Privacy</h5>
                <p>
                    Our App is not intended for children under 13. We do not knowingly collect personal information from children.
                </p>
                <hr />
                <h5 className='fw-bold'>11. Changes to This Policy</h5>
                <p>
                    We may update this Privacy Policy from time to time. Updates will be posted on our website, and the effective date will be revised accordingly.
                </p>
                <hr />
                <h5 className='fw-bold'>12. Contact Us</h5>
                <p>For questions about this Privacy Policy or to exercise your rights, please contact us:</p>
                <strong>Curry King (Private) Limited</strong>
                <br />
                55/72, Vauxhall Lane, Colombo 2, Sri Lanka
                <br />
                <strong>Email:</strong> support@curryking.lk
                <br />
                <strong>Phone:</strong> +94 11 444 1300
                <hr />
            </div>
        </>
    )
}

export default IosPrivacyPolicy;